<template>
    <div>
        <div  v-if="loading">
            Loading
        </div>
        <div v-else-if="dueDiligence" class='flex column gap-5'>
            <div class="flex align-start gap-5px bold">
                Part of <router-link target='_blank' :to="{
                    name: 'due-diligence-item', 
                    params: {
                        id: store.state.companyData._id,
                        item_id: dueDiligence._id
                    }
                }">Due Diligence</router-link>
            </div>
            <div class='flex w-full gap-5' >
                <div class="current-version flex-1 flex column" v-if="reviewAction.actionType == 'remove'">
                    <DueDiligence
                        :item_id="dueDiligence._id"
                        :id="store.state.companyData._id"
                        :reviewMode="true"
                        />
                </div> 
                <div v-else class='flex w-full gap-5'>
                    <div class="flex-1">
                        <DueDiligenceRecordFields
                            :changes="fieldChange"
                            :sourceObjectState="sourceObjectState"
                        />
                    </div>
                </div>
            </div>

        </div>
       
        <div v-else>
            No Data Found
        </div>
    </div>
</template>

<script setup >

import { ref, computed, onMounted, watch } from 'vue'
import dayjs from 'dayjs';

import { useStore } from 'vuex';
import DueDiligenceRecordFields from './DueDiligenceRecordFields.vue';
import API from '@/api/index.js'
import DueDiligence from '@/views/DueDiligence.vue';
const props = defineProps(['reviewAction', 'view', 'isReport'])
const store = useStore();

const fieldChange = ref(JSON.parse(props?.reviewAction?.fields || '{}'));
const sourceObjectState = ref(JSON.parse(props?.reviewAction?.sourceObjectState || '{}'));

const dueDiligence = ref(null);
const loading = ref(true);
onMounted(async() => {
    const dueDiligenceResponse = await API.getDueDiligenceRecordById({id: props.reviewAction.due_diligence_record, dependencies: true});
    if (!dueDiligenceResponse.status == 200) {
        return;
    }
    store.state.dueDiligenceRecord = dueDiligenceResponse.dueDiligenceRecord
    dueDiligence.value = dueDiligenceResponse.dueDiligenceRecord;
    loading.value = false;
});



function renderTime(time) {
    if (!time) return '';
    return dayjs(time).format('MMM DD, YYYY [at] HH:mm');
}


</script>

<style lang="scss" scoped>

    .proposed-changes {
        margin-left: auto;
        .changes {
            background: #DEF7EC;
            &:deep(label) {
                background: #DEF7EC;
            }
        }
    }
    .current-version {
       
        .changes {
            background: #FDE8E8;
            &:deep(label) {
                background: #FDE8E8;
            }
        }
    }
    .comment-info {
        flex: 3;
    }
    .info-holder {
        margin-bottom: 20px;
    }
    .info-line {
        color: black;
        text-align: left;
        font-weight: 600;
        margin: 0;
    }
    .line-label {
        text-align: left;
        font-weight: 600;
        margin: 0;
        margin-top: 5px;
        font-size: 12px;
        color: rgb(151, 151, 151);
    }
</style>